const fs = require('fs')
const path = require('path')

const fileUtils = {
  copyAttach: (originalFilePath, localFile) => {
    if (!fs.existsSync(originalFilePath)) {
      console.log(originalFilePath + ' :original file is not exists')
      return
    }

    return new Promise((resolve, reject) => {
      fs.copyFile(originalFilePath, localFile, (err) => {
        if (err)
          reject(err)
        resolve()
      })
    })
  },
  makeDir: (dir) => {
    if (!fs.existsSync(dir))
      fs.mkdirSync(dir)
  },
  removeDir: (directory) => {
    fs.readdir(directory, (err, files) => {
      if (err) throw err
      for (const file of files) {
        fs.unlink(path.join(directory, file), err => {
          if (err) throw err
        })
      }
    })
  },
  enumFiles: (dir) => {
    // TODO: filter files: stats.isFile()
    // TODO: sort by time creation
    if (!fs.existsSync(dir)) {
      console.log(dir + ' is not exists')
      return []
    }
    return fs.readdirSync(dir)
  },
  writeFile: (path, data) => {
    fs.writeFileSync(path, data)
  },
  removeFile: (path) => {
    if (fs.existsSync(path))
      fs.unlink(path,(error) => {});
  },
  extension: (filename) => {
    let extension = filename.split('.').pop()
    if (extension !== '')
      extension = '.' + extension
    return extension    
  }
}

export default fileUtils
